import { isAnyOf } from '@reduxjs/toolkit'
import { getUser } from 'legacy/lut/selectors/app'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { DEFAULT_NETNDP_PARTNER_USER_TYPES } from 'partner360/models/actualValueTypes'

import { changeProgramType } from '../api/changeProgramType'
import { setAvailableActualsTypes } from '../configurationSlice'
import { partnerDataFulfilled } from '../partnerDataLifecycle'
import { selectActualsData } from '../selectors/selectActualsData'

listenerMiddleware.startListening({
  matcher: isAnyOf(partnerDataFulfilled, changeProgramType.fulfilled),
  effect: (_, { getState, dispatch }) => {
    const state = getState()
    const user = getUser(state)
    const isPartnerUser = user.roleIds.some((role) => role === 'Partner User')
    if (isPartnerUser) {
      dispatch(setAvailableActualsTypes(DEFAULT_NETNDP_PARTNER_USER_TYPES))

      return
    }

    dispatch(setAvailableActualsTypes([...selectActualsData(state).valueTypes]))
  },
})
